import type { ZIndex } from '@mui/material/styles';

/**
 * Z-index.
 * Defaults: https://mui.com/material-ui/customization/z-index/
 */
export const zIndex: Partial<ZIndex> = {
	drawer: 1400,
	modal: 1300,
};
